import { render, staticRenderFns } from "./dialog-select-table.vue?vue&type=template&id=701cc70f"
import script from "./dialog-select-table.vue?vue&type=script&setup=true&lang=js"
export * from "./dialog-select-table.vue?vue&type=script&setup=true&lang=js"
import style0 from "./dialog-select-table.vue?vue&type=style&index=0&id=701cc70f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports